import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap, map, finalize } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(private router: Router, private apiService: ApiService) { }

  logout(): Observable<any> {
    console.log('=== LOGOUT SERVICE START ===');
    const loginDetails = localStorage.getItem('loginDetails');
    console.log('Login details check:', loginDetails ? 'EXISTS' : 'NOT FOUND');
    
    if (loginDetails) {
      console.log('Creating API call...');
      // Call logout API using ApiService
      const apiCall = this.apiService.getCitizenData('logout');
      console.log('API Observable created:', apiCall);
      console.log('Returning piped Observable...');
      
      const pipedObservable = apiCall.pipe(
        tap((res: any) => {
          console.log('TAP: Logout API success:', res);
        }),
        map((res: any) => {
          console.log('MAP: Processing response:', res);
          this.performLogoutCleanup();
          return { success: true, data: res };
        }),
        catchError((error) => {
          console.error('CATCH: Logout API error:', error);
          this.performLogoutCleanup();
          return of({ success: false, error: error.error?.error?.[0]?.message || 'Logout failed' });
        }),
        finalize(() => {
          console.log('FINALIZE: Logout API call completed');
        })
      );
      
      console.log('Piped Observable created:', pipedObservable);
      console.log('=== RETURNING OBSERVABLE ===');
      return pipedObservable;
    } else {
      console.log('No login details, performing cleanup only');
      this.performLogoutCleanup();
      return of({ success: true });
    }
  }

  private performLogoutCleanup(): void {
    console.log('CLEANUP: Performing logout cleanup...');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
